import React, { Component } from "react";
import config from "lib/fr-config";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import PickAndBookmarkFolderDropdownButtonView from "presentational/portfolio/PickAndBookmarkFolderDropdownButtonView";
import PickAndBookmarkFolderOptModalView from "presentational/portfolio/PickAndBookmarkFolderOptModalView";
import { getDeviceType } from "lib/deviceInfo";
import TXT from "presentational/common/multinational/TXT";
import IconButtonView from "presentational/common/IconButtonView";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const MORE_BTN_TYPE = config.iconDesign.moreButton;

const cssXL = {
  dropdownWrapper: {
    marginTop:
      desktopCss.paddingBetweenTextButton -
      desktopCss.standardPaddingBetweenContent,
    marginBottom: desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }
};

const cssXS = {
  dropdownWrapper: {
    marginTop:
      mobileCss.paddingBetweenTextButton -
      mobileCss.standardPaddingBetweenContent,
    marginBottom: mobileCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }
};

class BookmarkListView extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    bookmarkFolderList: PropTypes.array.isRequired,
    selectedFolderHash: PropTypes.string,
    onFolderChange: PropTypes.func.isRequired,
    callNextListFn: PropTypes.func.isRequired,
    onFolderCreateBtnSubmit: PropTypes.func.isRequired,
    onFolderEditBtnSubmit: PropTypes.func.isRequired,
    onFolderDeleteBtnSubmit: PropTypes.func.isRequired
  };

  state = {
    folderModalOpen: false
  };

  getFolderList = () => {
    const { bookmarkFolderList } = this.props;
    const returnArr = [];
    for (let i = 0; i < bookmarkFolderList.length; i++) {
      const { hash, name } = bookmarkFolderList[i];
      const text =
        hash === "all" ? <TXT name="msg_allOutfitOfDropdown" /> : name;

      returnArr.push({ value: hash, text });
    }
    return returnArr;
  };

  getNowFolderInfo = () => {
    const { bookmarkFolderList, selectedFolderHash } = this.props;
    if (!selectedFolderHash) return {};

    for (let i = 0; i < bookmarkFolderList.length; i++) {
      const { hash, name } = bookmarkFolderList[i];
      if (selectedFolderHash === hash) {
        return { hash, name };
      }
    }
  };

  handleOptBtnClick = () => {
    this.setState({ folderModalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ folderModalOpen: false });
  };

  getListElement = () => {
    const {
      list,
      isLoading,
      isEnd,
      selectedFolderHash,
      onFolderChange,
      callNextListFn
    } = this.props;

    const deviceType = getDeviceType();
    const css = deviceType === "mobile" ? cssXS : cssXL;

    return (
      <div>
        <div style={css.dropdownWrapper}>
          <PickAndBookmarkFolderDropdownButtonView
            type={"bookmarkFolder"}
            folderList={this.getFolderList()}
            selectedItem={selectedFolderHash}
            onSelect={onFolderChange}
          />
          <IconButtonView
            type={MORE_BTN_TYPE}
            disableRightMargin
            onClick={this.handleOptBtnClick}
            buttonSize={"small"}
            fontSize={"small"}
          />
        </div>
        <OutfitListView
          list={list}
          isLoading={isLoading}
          isEnd={isEnd}
          callNextListFn={callNextListFn}
          emptyListText={<TXT name="msg_emptyListBookmark" />}
        />
      </div>
    );
  };

  render() {
    const {
      selectedFolderHash,
      onFolderCreateBtnSubmit,
      onFolderEditBtnSubmit,
      onFolderDeleteBtnSubmit
    } = this.props;
    const { folderModalOpen } = this.state;

    return (
      <div>
        {this.getListElement()}
        {!!selectedFolderHash && (
          <PickAndBookmarkFolderOptModalView
            open={folderModalOpen}
            nowFolderInfo={this.getNowFolderInfo()}
            onFolderCreateBtnSubmit={onFolderCreateBtnSubmit}
            onFolderEditBtnSubmit={onFolderEditBtnSubmit}
            onFolderDeleteBtnSubmit={onFolderDeleteBtnSubmit}
            onClose={this.handleModalClose}
          />
        )}
      </div>
    );
  }
}

export default BookmarkListView;
